export default {
  title: 'Lorem Fidsum placeholder text generator',
  description: 'The ultimate placeholder text generator from the amusing, creative and damn right strange Slack chats by the bearded one, James Fidler. Obviously, these chats are in no particular order and out of context.',
  copyright: 'Copyright © <year> invisibleloop & James Fidler',
};
